import {
    productImageBackgroundGradient,
    productImageHoverBackgroundGradient,
} from "../../../design-tokens/01.colors/colors";
import { Box } from "../../layout/box/Box";
import { NextImage } from "../../media-and-icons/image/NextImage";
import { type CSSProperties, memo } from "react";
import { ECCOIcon } from "../../media-and-icons/ecco-icon/ECCOIcon";
import type { ECCOIconProps } from "../../media-and-icons/ecco-icon/ECCOIcon";

type ProductImageFrameProps = {
    src: string;
    priority?: boolean;
    alt: string;
    objectFit?: CSSProperties["objectFit"];
    quality?: number;
    isHovering?: boolean;
    sizes: string[];
    overlayIcon?: ECCOIconProps["name"];
};

export const ProductImageFrame = memo(
    ({
        src,
        priority = false,
        alt,
        objectFit = "contain",
        quality,
        isHovering = false,
        sizes,
        overlayIcon,
    }: ProductImageFrameProps) => {
        return (
            <Box
                background={
                    isHovering
                        ? productImageHoverBackgroundGradient
                        : productImageBackgroundGradient
                }
                width="100%"
                position="relative"
                aspectRatio="4/5"
                overflow="hidden"
            >
                <NextImage
                    src={src}
                    alt={alt}
                    objectFit={objectFit}
                    quality={quality}
                    priority={priority}
                    fill
                    sizes={sizes}
                    style={{
                        objectFit,
                        width: "100%",
                        height: "auto",
                    }}
                />
                {overlayIcon && (
                    <Box position="absolute" top={1} left={1} zIndex={1}>
                        <ECCOIcon name={overlayIcon} size="sm" color="black" />
                    </Box>
                )}
            </Box>
        );
    }
);

ProductImageFrame.displayName = "ProductImageFrame";

export default ProductImageFrame;
